import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import * as d3 from "d3";
import HoverableIcon from "../../components/Buttons/HoverableIcon ";
import { replaceDynamicValueLabel } from "../../util/utils";
import { store } from "../../util/store";
import ReusableAgGrid from "../../components/AgGrid/AgGrid";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  titleContainer: {
    width: "100%",
  },
}));

const Drilldown = (props) => {
  const [exportTrigger, setExportTrigger] = useState(0); // Each time we click, the number changes, triggering the useEffect in the child.

  console.log(props);

  const classes = useStyle();
  const Symbol = store.getState();
  const Currency_Symbol = Symbol.app.user.Currency;

  let acvLabel = props.acvName ? `${props.acvName}:` : "ACV";
  if (props.Value_Label) {
    acvLabel = replaceDynamicValueLabel(acvLabel, props.Value_Label);
  }

  const onCellClicked = (e) =>
    props.handleSecondLevelDrilldown
      ? props.handleSecondLevelDrilldown("drilldownOppId", e.data.Opp_ID)
      : "";

  const handleExport = () => {
    // Each time we click, the number changes, triggering the useEffect in the child.
    setExportTrigger((prevCount) => prevCount + 1);
  };

  return (
    <Grid container justify="center" className={classes.root}>
      {props.body ? (
        <React.Fragment>
          <Grid
            container
            justify="space-betweeen"
            className={classes.titleContainer}
            xs={props.showKey === "Quota" ? 7 : 12}
          >
            <Grid
              item
              container
              xs={10}
              justify="flex-start"
              alignItems="flex-end"
            >
              {props.showKey === "Quota" ? (
                <Typography variant="body1" style={{ fontWeight: "600" }}>
                  Number of Fiscal Quarters :{" "}
                  <span data-test="count">
                    {d3.format(",")(props.body.count_acv[0].count)}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Quota :{" "}
                  {`${Currency_Symbol}`}
                  <span data-test="acv">
                    {d3.format(",")(
                      Math.round(props.body.count_acv[0].Quota).toString()
                    )}
                  </span>
                </Typography>
              ) : props.showKey === "Certification" ? (
                <Typography variant="body1" style={{ fontWeight: "600" }}>
                  Number of Modules:{" "}
                  <span data-test="count">
                    {d3.format(",")(props.body.count_acv[0].count)}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Avg.Completion:{" "}
                  <span data-test="avgCompletion">
                    {d3.format(",")(
                      Math.round(
                        props.body.count_acv[0].PercentCompleted
                      ).toString()
                    )}
                    %
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Avg.Score:{" "}
                  <span data-test="avgScore">
                    {d3.format(",")(
                      Math.round(
                        props.body.count_acv[0].PercentScore
                      ).toString()
                    )}
                    %
                  </span>
                </Typography>
              ) : (
                <Typography variant="body1" style={{ fontWeight: "600" }}>
                  Number of opportunities:{" "}
                  <span data-test="count">
                    {d3.format(",")(props.body.count_acv[0].count)}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {`${acvLabel}`}:{" "}
                  {`${Currency_Symbol}`}{" "}
                  <span data-test="acv">
                    {d3.format(",")(
                      Math.round(props.body.count_acv[0].acv).toString()
                    )}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {props.body.count_acv[0].services
                    ? `Services: ${Currency_Symbol}`
                    : ""}{" "}
                  <span data-test="services">
                    {props.body.count_acv[0].services
                      ? d3.format(",")(
                          Math.round(props.body.count_acv[0].services)
                        )
                      : ""}
                  </span>
                </Typography>
              )}
            </Grid>
            <Grid
              direction="column"
              item
              container
              xs={2}
              justify="flex-end"
              alignItems="flex-end"
              alignContent="flex-end"
            >
              <Grid item justify="flex-end" style={{ paddingBottom: "1rem" }}>
                <button style={{ border: "none" }} onClick={handleExport}>
                  <HoverableIcon />
                </button>
              </Grid>
            </Grid>
          </Grid>

          <Grid xs={props.showKey === "Quota" ? 7 : 12}>
            <ReusableAgGrid
              rowData={props.body.opportunities}
              columnConfig={props.body.columns}
              onCellClicked={onCellClicked}
              isExportable={true}
              header={props.header}
              rawColumnDataForExport={props.body.columns}
              exportTrigger={exportTrigger}
            />
          </Grid>
        </React.Fragment>
      ) : (
        <Skeleton
          animation="wave"
          variant="rect"
          width="100%"
          height={280}
          style={{ margin: "20px 0px" }}
        />
      )}
    </Grid>
  );
};

export default Drilldown;
